import { render, staticRenderFns } from "./customerlevel.vue?vue&type=template&id=69da2b7e&"
import script from "./customerlevel.vue?vue&type=script&lang=js&"
export * from "./customerlevel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports